import React, { Fragment, useState, useEffect, useRef } from "react";
import useSorting from "../../hooks/Table/useSortableColumn";
import useFullscreen from "../../hooks/Screen/FullCloseScreen";
import useTableDensity from "../../hooks/Table/useToggleDensity";
import useDragAndDrop from "../../hooks/Table/useDragAndDrop";
import useGrouping from "../../hooks/Table/useGroupingTable";
import useDataInputHandler from "../../hooks/Table/useTableTbodyFire";
import { Link } from "react-router-dom";
import Pagination from "../../hooks/Table/usePagination";
import SearchBar from "../GlobalFeature/Table/HeadTop/SearchBar";
import FilterSearchTh from "../GlobalFeature/Table/HeadTop/FilterSearchTh";
import ToggleDensityMode from "../GlobalFeature/Table/HeadTop/ToggleDensityMode";
import FullScreenMode from "../GlobalFeature/Table/HeadTop/FullScreenMode";
import SettingHeader from "../GlobalFeature/Table/HeadTop/SettingHeader";
import SortingFilter from "../GlobalFeature/Table/TableThead/SortingFilter";
import ClearAllFilter from "../GlobalFeature/Table/HeadTop/ClearAllFilter";
import RenderElements from "../GlobalFeature/Others/RenderElements";
import useResizableColumn from "../../hooks/Table/useResizableColumn";
import TaskActivityList from "./TaskActivityList";
import CheckBox1 from "../GlobalFeature/CheckBox/CheckBox1";
import { parseJSONValue } from "../../utils/json/parseJSONValue";
import useRequireAuth from "../../utils/useRequireAuth";
import ActivityCounts from "./ActivityCounts";
import { Box, Popover } from "@mui/material";
import UserPopUpDetails from "../../utils/customer/UserPopupDetails";
import CustomerShowDetails from "./CustomerShowDetails";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Select, MenuItem, FormControl } from "@mui/material";
import { Autocomplete, TextField, InputLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import CustomerEditTaskActivity from "./CustomerEditTaskActivity";
import { useSelector } from "react-redux";
import { ReactComponent as SubTaskIcon } from "../../assets/images/subTaskIcon.svg";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as ThreeDotHorizontal } from "../../assets/images/threeDotHorizontal.svg";
import MuiLoader from "../GlobalFeature/Loader/MuiLoader";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from "../../assets/images/NewDelete.svg";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";

const getSearchFilterPayload = (filterOb) => {
  if (Object.keys(filterOb)?.length) {
    const searchfilters = {
      filters: Object.keys(filterOb).map((eachKey) => ({
        field_name: eachKey,
        operator: "contains",
        value: filterOb[eachKey],
      })),
    };

    return searchfilters;
  }
  return {};
};
// const useQuery = () => {
//   return new URLSearchParams(useLocation().search);
// };

const ToolTipEnableHeader = ["User Name", "Reporting"];
const CustomerListTable = ({
  totalData,
  tableDetail,
  thead,
  newPayload,
  setNewPayload,
  handlePostThead,
  tbody,
  tablePaginationData,

  fetchtableBodyData,
  customerCommnData,
  fetchPersonInTable,
  subTaskOpen,
  setSubTaskOpen,

  TableFieldUpdate,
  TableFieldInsideOptionAdd,
  ExtraFieldAddHeader,
  GetAdditionalField,
  GetAddFieldData,
  initialFilter,
  handleNavigate,
  navigateNameCondition = [],
  ExtraFieldComponent,
  handleDownload,
  handleDelete,
  handleEdite,
  handleStatusUpdate,
  downloadvalue,
  TextFieldElement,
  activityClosed,
  TableActiveFilter,
  TableTypeFilter,
  UserTypeFlag,
  UserActiveFlag,
  handleTypeChange,
  handleActiveChange,
  multiData,
  setMultiData,
  multiSelect,
  HoverOnCustomerName,
  openShowDetails,
  handleShowDetails,
  stickyHeaders,
  refetchCustomerData,
  isListLoading,
  setCustomerPayload,
  heightFull,
  navigateWithEdit = [],
}) => {
  const { token } = useRequireAuth();
  const [tableThSearch, setTableThSearch] = useState(false);
  const [tableSearchInput, setTableSearchInput] = useState("");
  const [searchTerms, setSearchTerms] = useState({});
  const [searchTermCount, setSearchTermCount] = useState(0);
  const [dataInputRow, setDataInputRow] = useState(null);
  const [tableSearch, setTableSearch] = useState(false);
  const [tablecellInput, setTablecellInput] = useState("");
  const [storedThead, setStoredThead] = useState(thead);
  const [hoveredCell, setHoveredCell] = useState(null);
  const [hoveredHeader, setHoveredHeader] = useState(null);
  const [showIconAct, setShowIconAct] = useState(false);
  const popupRefA = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupItemId, setPopupItemId] = useState(null);
  const [clientCoord, setClientCoord] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const timerRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(UserTypeFlag || "");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [statusTab, setStatusTab] = useState(false);
  const [openStates, setOpenStates] = useState(Array(thead?.length).fill(false));

  const [clickeditem, setClickedItem] = useState({});

  const handleOpen = (value) => setOpenDropdown(value);
  const handleClose = () => setOpenDropdown(null);

  const handleDataClick = (element) => {
    setStatusTab(element);
  };
  const navigate = useNavigate();
  const location = useLocation();
  //const query = useQuery();
  const updateUrlParams = (newParams) => {
    const params = new URLSearchParams(location.search);

    // Update the URLSearchParams with the new parameters
    Object.keys(newParams).forEach((key) => {
      params.set(key, newParams[key]);
    });

    // Update the URL with the new parameters
    navigate(`?${params.toString()}`);
  };

  const { columnWidths, handleMouseDown, tableRef, handleMouseOver, handleMouseLeave } = useResizableColumn();

  const firstColRef = useRef(null);
  const secondColRef = useRef(null);
  useEffect(() => {
    const storedData = localStorage.getItem(`sort-${tableDetail.tableHeading}`);
    const parsed = JSON.parse(storedData);

    if (storedData) {
      sortData(parsed.key, parsed.order);
    }
  }, []);
  useEffect(() => {
    const storedData = localStorage.getItem(`${tableDetail.tableHeading}`);

    if (storedData) {
      setTableThSearch(true);
      const parsedData = JSON.parse(storedData);
      setSearchTerms(parsedData);
      const [key, value] = Object.entries(parsedData)[0];
      handleInputChange(key, value);
    }
  }, []);
  useEffect(() => {
    const storedData = localStorage.getItem(`search-${tableDetail.tableHeading}`);
    if (storedData) {
      //setSearchBarExtra(true)
      setTableSearchInput(JSON.parse(storedData));
    }
  }, []);
  useEffect(() => {
    const filteredSearchTerms = Object.fromEntries(Object.entries(searchTerms).filter(([key, value]) => value !== ""));

    if (Object.keys(filteredSearchTerms).length > 0) {
      localStorage.setItem(`${tableDetail.tableHeading}`, JSON.stringify(filteredSearchTerms));
    } else {
      localStorage.removeItem(`${tableDetail.tableHeading}`);
    }
  }, [searchTerms]);
  useEffect(() => {
    if (tableSearchInput !== "") {
      localStorage.setItem(`search-${tableDetail.tableHeading}`, JSON.stringify(tableSearchInput));
    } else {
      localStorage.removeItem(`search-${tableDetail.tableHeading}`);
    }
  }, [tableSearchInput]);
  const handleGroupedHeader = (e, header, index) => {
    setGroupedHeaders((prev) => [...prev, { key: header.key, value: header.value }, openStates]);
    setOpenStates((prevState) => {
      return prevState.map(() => false);
    });
  };
  const handleHide = (header) => {
    setStoredThead((prevThead) => {
      const index = prevThead.findIndex((item) => Object.keys(item)[0] == header["key"]);

      if (index !== -1) {
        const updatedThead = [...prevThead];
        //let object=prevThead[index]
        //const secondKey = Object.keys(updatedThead[index])[1];
        const secondKey = Object.keys(updatedThead[index])[1];
        updatedThead[index] = {
          ...updatedThead[index],
          [secondKey]: 0,

          // (Object.keys(updatedThead[index]))[1]
        };
        return updatedThead;

        // const updatedThead = [...prevThead];
        // updatedThead[index] = {
        //     ...updatedThead[index],
        //     statuslabel: '0'
        // };
        // return updatedThead;
      }

      return prevThead;
    });
    setOpenStates((prevState) => {
      return prevState.map(() => false);
    });
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    handleTypeChange(value);
    handleClose();
  };

  const toggleDots = (event, index) => {
    setOpenStates((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenStates((prevState) => prevState.map(() => false));
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangeNew = (event) => {
    const value = event.target.value;
    setSelectedValue(value);

    if (value === 30) {
      setIsModalOpen(true);
      setSelectedValue("");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleMouseEnterDebounced = (item) => {
    setPopupItemId(item?.id?.value);
    setIsPopupOpen(true);
  };

  const handleClosed = () => {
    setPopupItemId(null);
    setIsPopupOpen(false);
    activityClosed();
  };

  const {
    draggedHeader,
    groupedHeaders,
    setGroupedHeaders,
    handleDragStart,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    isDragAccurateLoc,
    isDraggingOver,
    handleRemoveHeader,
  } = useDragAndDrop();

  const [collapsedRows, setCollapsedRows] = useState({});

  const { sortedData, sortData, sortKey, sortOrder, handleSearch, handleColumnSearch, clearAllFilters, headers } =
    useSorting(tbody, storedThead, "initial");

  // const options = [
  //   { label: 'Manish M', value: '1' },
  //   { label: 'BD', value: '2' },
  //   { label: 'IT', value: '3' },
  //   { label: 'Finace', value: '4' },
  // ];

  const { densityMode, densityIcons, toggleDensityMode } = useTableDensity();
  const { isFullscreen, toggleFullscreen, isTableMainDivPresent } = useFullscreen();

  const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 });

  const [columnDropdown, setColumnDropdown] = useState(false);
  const [groupedDropdown, setGroupedDropdown] = useState(false);
  const handleGroupedToggle = () => {
    setGroupedDropdown((prevState) => !prevState);
  };

  const { handleDataInput } = useDataInputHandler(fetchtableBodyData, setDataInputRow, setClientCoord);
  const groupedData = useGrouping(sortedData, groupedHeaders);
  useEffect(() => {
    setStoredThead(thead);
  }, [thead]);

  const toggleColumnDropdown = () => {
    setColumnDropdown(!columnDropdown);
  };

  const renderTableHeaders = () => {
    if (!Array.isArray(storedThead)) return null;

    return storedThead
      .filter((headerItem) => {
        const headerValue = headerItem[Object.keys(headerItem)[0]];
        return (
          Number(headerItem[Object.keys(headerItem)[1]]) === 1 &&
          !groupedHeaders?.some((groupedHeader) => groupedHeader?.value === headerValue)
        );
      })
      .map((headerItem, index) => ({
        key: Object.keys(headerItem)[0],
        label: headerItem[Object.keys(headerItem)[0]],
        statuskey: Object.keys(headerItem)[1],
        statuslabel: headerItem[Object.keys(headerItem)[1]],
        type: headerItem["field_type"],
      }));
  };

  useEffect(() => {
    // Only proceed if ref has been attached
    if (firstColRef.current) {
      const firstColWidth = firstColRef.current.clientWidth;
      document.documentElement.style.setProperty("--first-column-width", `${firstColWidth}px`);
    }
    if (secondColRef.current) {
      const secondColWidth = secondColRef.current.clientWidth;
      // Set the CSS variable on the root element
      document.documentElement.style.setProperty("--second-column-width", `${secondColWidth}px`);
    }
  }, [tbody, columnWidths, thead, renderTableHeaders]); // Empty dependency array to run only once after mount

  const handleGeneralSearch = (term) => {
    //handlePaginate(1);
    // setTimeout(() => {
    //   if (tableSearchInput !== term) {
    //     handlePaginate(1);
    //   }
    // }, 100);
    setTableSearchInput(term);
    handleSearch(term);
  };

  const handleInputChange = (headerKey, term) => {
    const newColumnSearchInputs = { ...searchTerms };
    newColumnSearchInputs[headerKey] = term;
    setSearchTerms((prev) => ({
      ...prev,
      [headerKey]: term,
    }));
    handleColumnSearch(term, headerKey);
    setSearchTermCount((prevState) => prevState + 1);
  };
  const removeAllGroupedHeaders = () => {
    setGroupedHeaders((prevState) => []);
  };

  const [perPage, setPerPage] = useState(initialFilter?.per_page || 20);
  const [currentPage, setCurrentPage] = useState(initialFilter?.current_page || 1);

  // Effect to handle URL changes and fetch data
  // useEffect(() => {
  //   const url = `?per_page=${perPage}&page=${currentPage}`;
  //   handleChangePage(url);
  // }, [perPage, currentPage]);

  const [menuVisible, setMenuVisible] = useState(false);
  const [extraField, setExtraField] = useState(false);
  const handleMenuToggle = () => {
    setMenuVisible((prev) => !prev);
    setExtraField(false);
  };

  const child1Ref = useRef(null);
  const scrollbarWrapperRef = useRef(null);
  const paginationRef = useRef(null);

  const handleScroll = (direction) => {
    if (scrollbarWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value to control the scroll speed
      const currentScroll = scrollbarWrapperRef.current.scrollLeft;

      // Correct scrolling logic based on direction
      if (direction === "next") {
        // Scroll right (increase scrollLeft)
        scrollbarWrapperRef.current.scrollLeft = currentScroll + scrollAmount;
      } else if (direction === "previous") {
        // Scroll left (decrease scrollLeft), but don't go below 0
        scrollbarWrapperRef.current.scrollLeft = Math.max(currentScroll - scrollAmount, 0);
      }
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get("page")) || 1;
    const entries = parseInt(params.get("entries")) || 20;
    // const pageFromQuery = Number(query.get('page'));
    // if (pageFromQuery !== currentPage) {
    //   setCurrentPage(pageFromQuery);
    // Fetch new data for the current page
    // console.log(`Fetching data for page: ${pageFromQuery}`);
    // fetchData(pageFromQuery); // Your data fetching function
    setCurrentPage(page);
    setPerPage(entries);
  }, [location.search]);
  useEffect(() => {
    // Calculate the total width of the table
    if (tableRef.current) {
      const tableWidth = tableRef.current.scrollWidth;
      const containerWidth = child1Ref.current.clientWidth;

      if (tableWidth > containerWidth + 20) {
        setScrollbarWidth(`${tableWidth}px`);
      } else {
        setScrollbarWidth("0px");
      }

      // setScrollbarWidth(`${tableWidth}px`);
    }
  }, [groupedData, stickyHeaders, renderTableHeaders]);

  const [scrollbarWidth, setScrollbarWidth] = useState("100%");

  useEffect(() => {
    const child1 = child1Ref.current;
    const scrollbarWrapper = scrollbarWrapperRef.current;
    if (child1 && scrollbarWrapper) {
      const handleScroll = () => {
        if (child1.scrollLeft !== scrollbarWrapper.scrollLeft) {
          child1.scrollLeft = scrollbarWrapper.scrollLeft;
        }
      };

      const handleChild1Scroll = () => {
        if (scrollbarWrapper.scrollLeft !== child1.scrollLeft) {
          scrollbarWrapper.scrollLeft = child1.scrollLeft;
        }
      };

      scrollbarWrapper.addEventListener("scroll", handleScroll);
      child1.addEventListener("scroll", handleChild1Scroll);
      // Cleanup event listeners on component unmount
      // return () => {
      //     scrollbarWrapper.removeEventListener('scroll', handleScroll);
      //     child1.removeEventListener('scroll', handleChild1Scroll);
      // };
    }
  }, []);

  const store = useSelector((store) => store.companyPermissionsData);
  const companyId = JSON.parse(localStorage.getItem("company_data"))?.company_id;
  useEffect(() => {
    const url = `?company_id=${companyId}&per_page=${perPage}&page=${currentPage}&search=${encodeURIComponent(tableSearchInput)}&sort_direction=${sortOrder}&sort_by=${sortKey}`;
    handleChangePage(url);
  }, [sortKey, sortOrder, tableSearchInput, perPage, currentPage]);

  useEffect(() => {
    if (setCustomerPayload) setCustomerPayload(getSearchFilterPayload(searchTerms));
  }, [searchTermCount]);

  // const updateStoredTheadWithWidth=()=>{
  //   setStoredThead(prevStoredThead =>
  //     prevStoredThead?.map((item, index) => {

  //       const columnWidthValue = columnWidths[index+1] !== undefined ? columnWidths[index+1] : null;

  //       return {
  //         ...item,
  //         columnwidth: columnWidthValue
  //       };
  //     })
  //   );

  // }
  const updateStoredTheadWithWidth = () => {
    setStoredThead(
      (prevStoredThead) =>
        Array.isArray(prevStoredThead) &&
        prevStoredThead?.map((item, index) => {
          const newColumnWidth = columnWidths[index + 1];

          const columnWidthValue =
            item.columnwidth !== null && newColumnWidth == null ? item.columnwidth : newColumnWidth;

          return {
            ...item,
            columnwidth: columnWidthValue ? columnWidthValue : null,
          };
        })
    );
  };
  useEffect(() => {
    updateStoredTheadWithWidth();
  }, [columnWidths]);

  const handleChangePage = (url) => {
    // Fetch data based on the URL
    tablePaginationData(url);
  };

  const handlePaginate = (page) => {
    // setCurrentPage(page);
    // navigate(`?page=${page}`);
    updateUrlParams({ page });
  };

  const DataElementShow = (event) => {
    //console.log("typeof",typeof (event.target.value));

    const entries = parseInt(event.target.value);
    //setPerPage(entries || 20);
    updateUrlParams({ entries });
    // setCurrentPage(1); // Reset to page 1 when per_page changes
  };

  const tableCellChange = (e) => {
    setTablecellInput(e.target.value);
  };

  const TableSearchData = (e) => {
    setTableSearch(!tableSearch);
  };

  const handleOtherDetailChange = (header, item, columnKey, event) => {
    if (!dataInputRow?.rowIndex) {
      handleDataInput(header, item, columnKey, event);
    }
  };

  const highlightText = (text, term, item) => {
    const parsedValue = parseJSONValue(text)?.value ? parseJSONValue(text) : text;

    const dataArray =
      typeof parsedValue?.value === "string" ? parsedValue?.value?.split(";").map((item) => item?.trim()) : [];

    const firstTwoItems = dataArray.slice(0, 2);
    const remainingItems = dataArray.slice(2);
    const remainingCount = dataArray.length - firstTwoItems.length;

    const DisplayedOptions = () => (
      <>
        {firstTwoItems.join("; ")}
        {remainingCount > 0 && (
          <Fragment>
            <span>;</span>
            <span className="border-2 rounded px-1 multiple-tooltip">
              +{remainingCount}
              <span className="multiple-tooltip-content !z-[9999999999999]">{remainingItems.join("; ")}</span>
            </span>
          </Fragment>
        )}
      </>
    );

    const formatDateForDisplay = (date) => {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    };

    if (text?.field_name?.includes("date")) {
      return formatDateForDisplay(parsedValue?.value) ?? "";
    }

    if (!term) return remainingCount > 0 ? <DisplayedOptions /> : (parsedValue?.value ?? "");

    const regex = new RegExp(`(${term})`, "gi");

    const highlight = (str) => {
      if (typeof str !== "string") return str;

      return str.split(regex).map((part, index) =>
        regex.test(part?.toLowerCase()) ? (
          <span key={index} className="whitespace-pre-wrap" style={{ backgroundColor: "rgb(255, 203, 127)" }}>
            {part}
          </span>
        ) : (
          <span className="accounting-ellipsis w-[120px]">{part}</span>
        )
      );
    };

    if (typeof parsedValue === "string") {
      return highlight(parsedValue?.value);
    }

    if (parsedValue !== null && typeof parsedValue === "object" && "value" in parsedValue) {
      return highlight(parsedValue?.value);
    }

    return parsedValue;
  };

  const toggleCollapse = (rowKey) => {
    setCollapsedRows((prevState) => ({
      ...prevState,
      [rowKey]: !prevState[rowKey],
    }));
  };

  const updateTableField = (e, item, completedata) => {
    e.stopPropagation();
    TableFieldUpdate(item, completedata, multiData);
    setDataInputRow(null);
  };

  const handleMouseEnter = (e) => {
    const cellRect = e.target.getBoundingClientRect();
    setHoverPosition({
      top: cellRect.bottom,
      left: cellRect.left,
    });
  };
  const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
    ({ theme }) => ({
      [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
        "&::before": {
          backgroundColor: theme.palette.common.white,
        },
      },
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "white",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: theme.typography.pxToRem(12),
        // border: '1px solid #dadde9',
        padding: "0px",
        boxShadow: "0px 0px 14.091px rgba(44, 73, 93, 0.30)",
      },
    })
  );

  const getNotAvailableTagForGrouped = (item, header, returnedValue) => {
    if (Boolean(groupedHeaders?.length && !item[header.key]?.value)) return "NA";
    return returnedValue;
  };

  const [isDetailsVisible, setDetailsVisible] = useState(false);

  const getPersonAvatar = (personList, header, rowKey) => {
    const toggleDetails = (event, header, rowKey, eachInput) => {
      event.stopPropagation();
      setDetailsVisible((prevState) => !prevState);
      setClickedItem({ columnKey: header.key, rowIndex: rowKey, data: eachInput });
    };

    const handleCloseDetails = (event) => {
      event.stopPropagation();
      setDetailsVisible((prevState) => !prevState);
    };

    return (
      <div className="w-full">
        <div className="pt-1 space-x-1 flex items-end">
          {Array.isArray(personList) &&
            personList
              ?.filter((assigned, index) => index < 3)
              .map((eachInput, index) => {
                const initials = eachInput.name
                  .split(" ")
                  .filter((word) => word.length > 0)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(0, 2)
                  .join("");
                const fullName = eachInput.name;

                return (
                  <div key={index} className="relative">
                    <Tooltip
                      title={
                        <>
                          <div className="py-2 min-w-[249px]">
                            <div className="rounded-lg bg-white">
                              <div className="border-b-2 space-y-2 pb-2">
                                <div className="flex px-2 space-x-2">
                                  <div>
                                    <AvatarName
                                      name={initials}
                                      size="small"
                                      bgColor={"#E8ECF299"}
                                      textColor={"#7C7C83"}
                                      borderColor={"#ABABAC"}
                                    />
                                  </div>
                                  <div className="text-2999BC text-14">{fullName}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <EmailIcon />
                                  </div>
                                  <div className="text-F16136 text-12">{eachInput?.email}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <PhoneIcon />
                                  </div>
                                  <div className="text-F16136 text-12">
                                    {eachInput.mobile ? eachInput?.mobile : "Not Avaliable"}
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-end mt-2 me-5 text-12">
                                <button
                                  className="text-blue-500"
                                  onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                                >
                                  {isDetailsVisible ? "Show more" : "Show more"}
                                </button>
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </>
                      }
                      PopperProps={{ style: { zIndex: 99999 } }}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.white",
                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            color: "#383838",
                            "& .MuiTooltip-arrow": {
                              color: "common.white",
                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className={` ${eachInput?.c_key ? "text-white border-white" : "text-[#7C7C83] border-[#ABABAC]"} text-12 font-400   p-[10px] w-7 h-7 flex items-center justify-center rounded-full border-[1px]`}
                        style={{ backgroundColor: eachInput?.c_key ? eachInput?.c_key : "#E8ECF2" }}
                      >
                        {initials}
                      </div>
                    </Tooltip>

                    {/* <button
                className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
              // onClick={(e) => handleSelectPerson(e, eachInput)} */}
                    {/* >
                &times;
              </button> */}
                  </div>
                );
              })}

          {personList?.length > 3 && (
            <div className="">
              <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300 w-7 h-7 flex items-center justify-center rounded-full border-[1px] ">
                +{personList?.length - 3}
              </div>
            </div>
          )}
          {isDetailsVisible &&
            clickeditem &&
            clickeditem.rowIndex === rowKey &&
            clickeditem.columnKey === header.key && (
              <CustomerShowDetails
                open={
                  isDetailsVisible &&
                  clickeditem &&
                  clickeditem.rowIndex === rowKey &&
                  clickeditem.columnKey === header.key
                }
                onClose={handleCloseDetails}
                Data={{
                  customerData: { customer_id: { value: parseJSONValue(clickeditem?.data?.id) } },
                  headerKey: "",
                }}
              />
            )}
        </div>
      </div>
    );
  };

  const renderCellContent = (item, header, searchTerms, tableSearchInput, rowKey, tdWidth) => {
    const DataText = highlightText(item[header.key], searchTerms[header.key] || tableSearchInput);
    const TextElement = TextFieldElement && TextFieldElement[header?.type] && (
      <div className="min-h-[20px] w-full">{TextFieldElement[header?.type]("DataText", tableDetail)}</div>
    );

    if (item[header.key]?.type === "multi_person") {
      return getPersonAvatar(JSON.parse(item[header.key]?.value), header, rowKey);
    }
    // const TextElement = TextFieldElement &&
    //   TextFieldElement[item[header.key]?.type] && (
    //     <Fragment>
    //       {TextFieldElement[item[header.key]?.type](DataText, tableDetail)}
    //     </Fragment>
    //   );
    // {groupedHeaders?.length && console.log(groupedHeaders.length,"groupedHeaders aakash")}
    // return <div className="min-h-[20px] w-full " >{getNotAvailableTagForGrouped(item,header,TextElement ?? DataText)}</div>
    return (
      <div
        className={`${tableDetail?.tableHeading?.toLowerCase() === "All Tasks"?.toLowerCase() ? "" : "min-h-[20px]"}  overflow-hidden text-ellipsis `}
        style={{
          width: `[${tdWidth}px]`,
          minWidth: tableDetail?.tableHeading?.toLowerCase() === "All Tasks"?.toLowerCase() ? "" : "2vw",
          maxWidth: "fit-content",
        }}
      >
        {TextElement ?? DataText}
      </div>
    );
  };
  //
  const onFocus = () => {};
  // const [openDialog,setOpenDialog]=useState(false)
  // const handleOpenDialog=()=>{
  //   setOpenDialog(true)

  const [popoverData, setPopoverData] = useState({});
  const handleFocusCustomer = (item, header) => {
    setPopoverData(item);
  };

  const centeredLoader = () => (
    <td colSpan={"10%"} className="text-black bg-gray-500">
      <div className="bg-container-spinner  min-h-[200px]">
        <div className="spinner">Loading...</div>
      </div>
    </td>
  );
  const renderTableRows = (data, level = 0, isSubtask) => {
    return data?.map((item, index) => {
      const firstKey = Object.keys(item).find((key) => key === "uuid") || Object.keys(item)[0];
      const parsedValue = parseJSONValue(item) || {};
      const rowKey = item[firstKey]?.value;
      console.log(rowKey, "rowKey");
      const isParent = Boolean(item?.value);
      const latestGroupedHeader = groupedHeaders.length > 0 ? groupedHeaders[groupedHeaders.length - 1].key : "";
      const isCollapsed = collapsedRows[item.groupKey];
      const parsedlatestGrp = parseJSONValue(item[latestGroupedHeader]);
      const handleChangeCheckox = (event, indexValue) => {
        const value = event.target.value;
        let newCheckedItems = structuredClone(multiData);

        if (event?.nativeEvent.shiftKey) {
          // const start = Math.min(lastCheckedIndex, value);

          const start = Math.min(lastCheckedIndex ?? Number.POSITIVE_INFINITY, indexValue);
          const end = Math.max(lastCheckedIndex, indexValue);

          data?.forEach((item, indexForEach) => {
            if (start <= indexForEach && indexForEach <= end) newCheckedItems[item?.id?.id] = true;
          });
          setLastCheckedIndex(indexValue);

          // for (let i = start; i <= end; i++) {

          // }
          setMultiData(newCheckedItems);
        } else {
          setMultiData((prevMultiData) => {
            const newSelectedValues = { ...prevMultiData };
            if (newSelectedValues[value]) {
              delete newSelectedValues[value];
              const keys = Object.keys(newSelectedValues);
              const lastKey = keys[keys.length - 1];
              setLastCheckedIndex(lastKey);
            } else {
              newSelectedValues[value] = true;
              setLastCheckedIndex(indexValue);
              //console.log("newSelectedValues2210",newSelectedValues);
            }
            if (Object.keys(newSelectedValues)?.length === 0) {
              setLastCheckedIndex(null);
            }
            return newSelectedValues;
          });
        }
      };

      return (
        <Fragment key={rowKey}>
          {/* <tr className={`border  border-neutral-200 tablerow`}> */}
          <tr className={` border  tablerow border-E1E6EC ${isSubtask ? "subtask-tr  bg-[#F2F4F5] " : ""}`}>
            {groupedHeaders?.length > 0 && (
              <td
                className={` font-normal px-6 py-3 text-left border whitespace-nowrap border-x-0`}
                style={{ paddingLeft: `${level !== 0 && level * 30}px` }}
              >
                {isParent && (
                  <Fragment>
                    {parsedValue?.value} ({item.items.length}){" "}
                    {isCollapsed ? (
                      <button onClick={() => toggleCollapse(item.groupKey)}>▶</button>
                    ) : (
                      <button onClick={() => toggleCollapse(item.groupKey)}>▼</button>
                    )}
                  </Fragment>
                )}
                {!isParent && (
                  <Link
                    className="text-2999BC"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleNavigate(rowKey, item);
                    }}
                  >
                    {" "}
                    {parsedlatestGrp?.value}{" "}
                  </Link>
                )}
              </td>
            )}

            {!isParent && (
              <Fragment>
                {multiSelect && (
                  <td className="bg-white z-[1] sticky left-[-1px] w-[20px]">
                    <input
                      key={index}
                      type="checkbox"
                      className=" cursor-pointer switch border-gray-300  hover:border-[#005B88] checked:bg-[#005B88]"
                      value={item?.id?.id}
                      checked={multiData[item?.id?.id]}
                      onChange={(e) => handleChangeCheckox(e, index)}
                    />
                  </td>
                )}

                {renderTableHeaders() &&
                  renderTableHeaders().map((header, headerIndex) => {
                    const isDataInputRow =
                      dataInputRow && dataInputRow?.rowIndex === rowKey && dataInputRow?.columnKey === header.key;
                    const isDifferentCell =
                      dataInputRow && (dataInputRow.rowIndex !== rowKey || dataInputRow.columnKey !== header.key);
                    const parsedValue = parseJSONValue(item[header.key]);

                    const statusvalue = parseInt(item?.status?.value) === 0 && header.key !== "action";
                    // Table Body Data begins here
                    return (
                      Number(header.statuslabel) === 1 && (
                        <td
                          key={headerIndex}
                          className={`${stickyHeaders && stickyHeaders[header.key]?.name === header.key ? `bg-white z-[1]  sticky-col-customer  ` : ""} whitespace-nowrap border-b  border-e border-neutral-200 text-2C495D font-normal text-left text-[12px] ${
                            item?.access_type?.value === "Owner" && header.key === "action" ? "" : "cursor-pointer"
                          } border-r-0
                              ${isDataInputRow ? "p-0" : "py-0.5"}
                              ${
                                isDifferentCell ||
                                statusvalue ||
                                (tableDetail?.forcefullyfreeze &&
                                  (!navigateNameCondition || !navigateNameCondition.includes(header.key)))
                                  ? "pointer-events-none freezetd"
                                  : ""
                              }
                            `}
                          style={
                            {
                              // left: stickyHeaders && (stickyHeaders[header.key]?.width-columnWidths[headerIndex + 1]),
                              // width: columnWidths[headerIndex + 1], minWidth: "2vw"
                            }
                          }
                          onClick={(event) => {
                            if (
                              !statusvalue &&
                              header.key !== "action" &&
                              header.key !== "activity" &&
                              (!navigateNameCondition ||
                                !navigateNameCondition.includes(header.key) ||
                                navigateWithEdit.includes(header.key))
                            ) {
                              handleOtherDetailChange(rowKey, item, header.key, event);
                            }
                          }}
                          onMouseEnter={() => {
                            if (
                              !navigateNameCondition ||
                              !navigateNameCondition.includes(header.key) ||
                              HoverOnCustomerName
                            ) {
                              setHoveredCell({
                                rowIndex: rowKey,
                                columnKey: header.key,
                              });
                            }
                            // else{
                            //   console.log(header,"header.key")
                            // }
                          }}
                          onMouseLeave={() => setHoveredCell(null)}
                        >
                          <div
                            className={`clickopennow flex items-center ${
                              isSubtask && header?.key === "subject" ? "gap-1" : "justify-between"
                            } relative  ${isSubtask && header?.key === "subject" ? "ms-8" : "ms-5"}`}
                          >
                            {isSubtask && header?.key === "subject" && (
                              // <svg
                              //   className="mt-1 mr-2"
                              //   xmlns="http://www.w3.org/2000/svg"
                              //   width="10"
                              //   height="10"
                              //   viewBox="0 0 10 10"
                              //   fill="none"
                              // >
                              //   <path
                              //     fill-rule="evenodd"
                              //     clip-rule="evenodd"
                              //     d="M1.98401 2.16334e-07H8.016C8.2353 -4.78367e-06 8.42455 -9.83011e-06 8.5812 0.0106752C8.7461 0.0219302 8.91105 0.0466802 9.07405 0.11418C9.44155 0.26642 9.7336 0.558435 9.8858 0.925975C9.9533 1.08894 9.97805 1.2539 9.98935 1.41881C10 1.57544 10 1.76468 10 1.98401V2.016C10 2.23532 10 2.42457 9.98935 2.58119C9.97805 2.74611 9.9533 2.91106 9.8858 3.07403C9.7336 3.44157 9.44155 3.73358 9.07405 3.88582C8.91105 3.95332 8.7461 3.97808 8.5812 3.98933C8.42455 4 8.2353 4 8.016 4H2.5V6.4C2.5 6.6883 2.50039 6.8744 2.51197 7.0161C2.52306 7.1519 2.5419 7.20225 2.5545 7.227C2.60244 7.3211 2.67893 7.39755 2.77301 7.4455C2.79773 7.4581 2.84809 7.47695 2.98392 7.48805C3.12559 7.4996 3.31173 7.5 3.6 7.5H4.00615C4.0074 7.47205 4.0089 7.44495 4.0107 7.4188C4.02195 7.2539 4.0467 7.08895 4.1142 6.926C4.2664 6.55845 4.55845 6.2664 4.926 6.1142C5.08895 6.0467 5.2539 6.02195 5.4188 6.0107C5.57545 6 5.7647 6 5.984 6H8.016C8.2353 6 8.42455 6 8.5812 6.0107C8.7461 6.02195 8.91105 6.0467 9.07405 6.1142C9.44155 6.2664 9.7336 6.55845 9.8858 6.926C9.9533 7.08895 9.97805 7.2539 9.98935 7.4188C10 7.57545 10 7.7647 10 7.984V8.016C10 8.2353 10 8.42455 9.98935 8.5812C9.97805 8.7461 9.9533 8.91105 9.8858 9.07405C9.7336 9.44155 9.44155 9.7336 9.07405 9.8858C8.91105 9.9533 8.7461 9.97805 8.5812 9.98935C8.42455 10 8.2353 10 8.016 10H5.984C5.7647 10 5.57545 10 5.4188 9.98935C5.2539 9.97805 5.08895 9.9533 4.926 9.8858C4.55845 9.7336 4.2664 9.44155 4.1142 9.07405C4.0467 8.91105 4.02195 8.7461 4.0107 8.5812C4.0089 8.55505 4.0074 8.52795 4.00615 8.5H3.58072C3.31715 8.5 3.08977 8.5 2.90249 8.4847C2.70482 8.46855 2.50821 8.4329 2.31902 8.3365C2.03677 8.1927 1.8073 7.96325 1.66349 7.681C1.5671 7.4918 1.53144 7.2952 1.51529 7.0975C1.49999 6.91025 1.49999 6.68285 1.5 6.41925V3.99384C1.47204 3.9926 1.44497 3.99111 1.41881 3.98933C1.2539 3.97808 1.08894 3.95332 0.925975 3.88582C0.558435 3.73358 0.26642 3.44157 0.11418 3.07403C0.0466802 2.91106 0.0219302 2.74611 0.0106752 2.58119C-9.83011e-06 2.42457 -4.78367e-06 2.23532 2.16334e-07 2.01599V1.98401C-4.78367e-06 1.76469 -9.83011e-06 1.57544 0.0106752 1.41881C0.0219302 1.2539 0.0466802 1.08894 0.11418 0.925975C0.26642 0.558435 0.558435 0.26642 0.925975 0.11418C1.08894 0.0466802 1.2539 0.0219302 1.41881 0.0106752C1.57544 -9.83011e-06 1.76469 -4.78367e-06 1.98401 2.16334e-07ZM1.48688 1.00836C1.37288 1.01614 1.32947 1.02944 1.30866 1.03806C1.18615 1.08881 1.08881 1.18615 1.03806 1.30866C1.02944 1.32947 1.01614 1.37288 1.00836 1.48688C1.00027 1.60537 1 1.76019 1 2C1 2.23982 1.00027 2.39463 1.00836 2.51312C1.01614 2.62712 1.02944 2.67054 1.03806 2.69135C1.08881 2.81386 1.18615 2.9112 1.30866 2.96194C1.32947 2.97056 1.37288 2.98387 1.48688 2.99165C1.60537 2.99973 1.76019 3 2 3H8C8.2398 3 8.39465 2.99973 8.5131 2.99165C8.6271 2.98387 8.67055 2.97056 8.69135 2.96194C8.81385 2.9112 8.9112 2.81386 8.96195 2.69135C8.97055 2.67054 8.98385 2.62712 8.99165 2.51312C8.99975 2.39463 9 2.23982 9 2C9 1.76019 8.99975 1.60537 8.99165 1.48688C8.98385 1.37288 8.97055 1.32947 8.96195 1.30866C8.9112 1.18615 8.81385 1.08881 8.69135 1.03806C8.67055 1.02944 8.6271 1.01614 8.5131 1.00836C8.39465 1.00027 8.2398 1 8 1H2C1.76019 1 1.60537 1.00027 1.48688 1.00836ZM5.4869 7.00835C5.3729 7.01615 5.32945 7.02945 5.30865 7.03805C5.18615 7.0888 5.0888 7.18615 5.03805 7.30865C5.02945 7.32945 5.01615 7.3729 5.00835 7.4869C5.00025 7.60535 5 7.7602 5 8C5 8.2398 5.00025 8.39465 5.00835 8.5131C5.01615 8.6271 5.02945 8.67055 5.03805 8.69135C5.0888 8.81385 5.18615 8.9112 5.30865 8.96195C5.32945 8.97055 5.3729 8.98385 5.4869 8.99165C5.60535 8.99975 5.7602 9 6 9H8C8.2398 9 8.39465 8.99975 8.5131 8.99165C8.6271 8.98385 8.67055 8.97055 8.69135 8.96195C8.81385 8.9112 8.9112 8.81385 8.96195 8.69135C8.97055 8.67055 8.98385 8.6271 8.99165 8.5131C8.99975 8.39465 9 8.2398 9 8C9 7.7602 8.99975 7.60535 8.99165 7.4869C8.98385 7.3729 8.97055 7.32945 8.96195 7.30865C8.9112 7.18615 8.81385 7.0888 8.69135 7.03805C8.67055 7.02945 8.6271 7.01615 8.5131 7.00835C8.39465 7.00025 8.2398 7 8 7H6C5.7602 7 5.60535 7.00025 5.4869 7.00835Z"
                              //     fill="#1D4469"
                              //   />
                              // </svg>
                              <div className="flex items-center justify-center bg-white rounded-10px border w-[21px] h-[21px] mr-1">
                                <SubTaskIcon className="" />
                              </div>
                            )}
                            {dataInputRow &&
                            dataInputRow.rowIndex === rowKey &&
                            dataInputRow.columnKey === header.key ? (
                              <Fragment>
                                <div className="relative w-full">
                                  <RenderElements
                                    tableDetail={tableDetail}
                                    fetchPersonInTable={fetchPersonInTable}
                                    Item={item}
                                    Header={header}
                                    RowKey={rowKey}
                                    CommonData={customerCommnData}
                                    CellChange={tableCellChange}
                                    CellInput={tablecellInput}
                                    setDataRow={setDataInputRow}
                                    DataRow={dataInputRow}
                                    UpdateField={updateTableField}
                                    clientCoord={clientCoord}
                                    refetchCustomerData={refetchCustomerData}
                                    multiData={multiData}
                                  />
                                </div>
                              </Fragment>
                            ) : (
                              <Fragment>
                                {header.key === "action" || header.key === "activity" ? (
                                  <div className="flex items-center space-x-2">
                                    {header.key === "activity" && !isSubtask && tableDetail?.dataactivity === true ? (
                                      <div className="relative">
                                        {/* <i
                                          className="bi-hdd-stack icon-colorG"
                                          onClick={() => handleMouseEnterDebounced(item)}
                                        >
                                          {item?.activityCount?.value > 0 && (
                                            <i className="bi bi-circle-fill text-D93916 relative bottom-[6px] ms-1 due-info">
                                              <span className="text-white text-xs absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                                                {item?.activityCount?.value}
                                              </span>
                                            </i>
                                          )}
                                        </i> */}

                                        <span onClick={() => handleMouseEnterDebounced(item)}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="13"
                                            viewBox="0 0 19 13"
                                            fill="none"
                                          >
                                            <path
                                              d="M16.5463 0H4.73224C4.07977 0 3.55083 0.528853 3.55083 1.18122C3.55083 1.83358 4.07977 2.36243 4.73224 2.36243H16.5463C17.1987 2.36243 17.7277 1.83358 17.7277 1.18122C17.7277 0.528853 17.1987 0 16.5463 0Z"
                                              fill="#B6B6B6"
                                            />
                                            <path
                                              d="M2.36943 1.18122C2.3681 0.868453 2.24276 0.568977 2.02091 0.348459C1.56013 -0.109521 0.815917 -0.109521 0.355132 0.348459C0.13325 0.568977 0.00790987 0.868453 0.00661771 1.18122C-0.0022059 1.25774 -0.0022059 1.33503 0.00661771 1.41155C0.0199824 1.48852 0.0417645 1.56378 0.071595 1.63598C0.103308 1.70594 0.140855 1.77312 0.183828 1.83679C0.226248 1.90301 0.275756 1.9644 0.331504 2.01988C0.385258 2.0734 0.44466 2.12095 0.508715 2.16163C0.570923 2.20692 0.638374 2.24461 0.709553 2.27384C0.787858 2.31445 0.871332 2.34427 0.957648 2.36243C1.03418 2.371 1.11149 2.371 1.18802 2.36243C1.49999 2.36269 1.7994 2.23955 2.02091 2.01988C2.07666 1.9644 2.12617 1.90301 2.16859 1.83679C2.21156 1.77312 2.24911 1.70594 2.28082 1.63598C2.31852 1.56467 2.34824 1.4894 2.36943 1.41155C2.37825 1.33503 2.37825 1.25774 2.36943 1.18122Z"
                                              fill="#B6B6B6"
                                            />
                                            <path
                                              d="M2.36943 6.49669C2.37821 6.42017 2.37821 6.34287 2.36943 6.26635C2.34901 6.19013 2.31925 6.11675 2.28082 6.04783C2.2504 5.97537 2.21278 5.90612 2.16859 5.84112C2.12765 5.77563 2.07795 5.71602 2.02091 5.66393C1.56013 5.20595 0.815917 5.20595 0.355132 5.66393C0.133249 5.88445 0.00790987 6.18393 0.00661771 6.49669C0.00890668 6.65235 0.0389217 6.80632 0.0952231 6.95146C0.124832 7.02134 0.160422 7.08852 0.201549 7.15227C0.24648 7.21646 0.297945 7.27585 0.355132 7.32945C0.407335 7.38637 0.466922 7.43605 0.532343 7.4771C0.594551 7.52243 0.661965 7.56012 0.733182 7.58932C0.80521 7.61962 0.880562 7.64144 0.957648 7.65428C1.03322 7.67123 1.11057 7.67916 1.18802 7.67791C1.26456 7.68673 1.34186 7.68673 1.4184 7.67791C1.49356 7.66503 1.56696 7.64321 1.63696 7.61294C1.71009 7.58393 1.7795 7.54624 1.8437 7.50073C1.90912 7.45968 1.96871 7.40999 2.02091 7.35307C2.07784 7.30088 2.12753 7.2413 2.16859 7.17589C2.214 7.11373 2.25169 7.04633 2.28082 6.97508C2.32117 6.89668 2.35097 6.81326 2.36943 6.72703C2.37851 6.65051 2.37851 6.57321 2.36943 6.49669Z"
                                              fill="#B6B6B6"
                                            />
                                            <path
                                              d="M2.36943 11.8122C2.37818 11.7356 2.37818 11.6583 2.36943 11.5818C2.34901 11.5037 2.31925 11.4284 2.28082 11.3574C2.24911 11.2874 2.21156 11.2203 2.16859 11.1566C2.12753 11.0912 2.07784 11.0316 2.02091 10.9794C1.56013 10.5214 0.815917 10.5214 0.355132 10.9794C0.298203 11.0316 0.24851 11.0912 0.207456 11.1566C0.164483 11.2203 0.126936 11.2874 0.0952231 11.3574C0.0645804 11.4293 0.0427613 11.5047 0.0302458 11.5818C0.0135954 11.6575 0.00569474 11.7347 0.00661771 11.8122C0.00794679 12.1249 0.133286 12.4244 0.355132 12.6449C0.407335 12.7018 0.466922 12.7515 0.532343 12.7926C0.594551 12.8379 0.661965 12.8756 0.733182 12.9048C0.80521 12.9351 0.880562 12.9569 0.957648 12.9698C1.03322 12.9867 1.11057 12.9946 1.18802 12.9934C1.26456 13.0022 1.34186 13.0022 1.4184 12.9934C1.49356 12.9805 1.56696 12.9587 1.63696 12.9284C1.71009 12.8994 1.7795 12.8617 1.8437 12.8162C1.90912 12.7752 1.96871 12.7255 2.02091 12.6685C2.07784 12.6164 2.12753 12.5568 2.16859 12.4914C2.21404 12.4292 2.25173 12.3618 2.28082 12.2906C2.32114 12.2121 2.35093 12.1287 2.36943 12.0425C2.37851 11.966 2.37851 11.8887 2.36943 11.8122Z"
                                              fill="#B6B6B6"
                                            />
                                            <path
                                              d="M17.7277 5.31547H4.73224C4.07977 5.31547 3.55083 5.84433 3.55083 6.49669C3.55083 7.14906 4.07977 7.67791 4.73224 7.67791H17.7277C18.3802 7.67791 18.9091 7.14906 18.9091 6.49669C18.9091 5.84433 18.3802 5.31547 17.7277 5.31547Z"
                                              fill="#B6B6B6"
                                            />
                                            <path
                                              d="M12.4114 10.6309H4.73224C4.07977 10.6309 3.55083 11.1598 3.55083 11.8122C3.55083 12.4645 4.07977 12.9934 4.73224 12.9934H12.4114C13.0638 12.9934 13.5928 12.4645 13.5928 11.8122C13.5928 11.1598 13.0638 10.6309 12.4114 10.6309Z"
                                              fill="#B6B6B6"
                                            />
                                          </svg>
                                        </span>

                                        {popupItemId === item?.id?.value && isPopupOpen && (
                                          <CustomerEditTaskActivity
                                            open={popupItemId === item?.id?.value && isPopupOpen}
                                            taskid={popupItemId}
                                            withDrawer
                                            cross
                                            onClose={handleClosed}
                                            handleNotification={handleClosed}
                                            item={item}
                                          />
                                        )}
                                      </div>
                                    ) : null}
                                    {tableDetail?.downloaddata === true && (
                                      <i
                                        className="bi bi-download text-18 text-1D4469 font-500 "
                                        onClick={() => handleDownload(rowKey, item, item.file_name)}
                                      />
                                    )}
                                    {tableDetail?.statusUpdate === true && (
                                      <CheckBox1
                                        Item={item}
                                        UpdateCheckBox={(e) => {
                                          e.stopPropagation();
                                          handleStatusUpdate(rowKey, item, item.id, e.target.checked);
                                        }}
                                      />
                                    )}
                                    {tableDetail?.datetedata === true && item?.access_type?.value !== "Owner" && (
                                      <button
                                        type="button"
                                        className="cursor-pointer"
                                        onClick={() => handleDelete(rowKey, item, item.id)}
                                      >
                                        {/* <i className="bi bi-trash3 text-lg text-F84545 font-600 cursor-pointer" /> */}
                                        <img src={DeleteIcon} alt="Icon" className="" />
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <Fragment>
                                    <div
                                      onMouseEnter={handleMouseEnter}
                                      className={`flex relative items-center max-w-fit  ${header?.type === "person" && "persontype"} ${
                                        !tableDetail?.allrowclicknavigate &&
                                        navigateNameCondition &&
                                        navigateNameCondition.includes(header.key)
                                          ? "text-2999BC"
                                          : "text-black"
                                      }
                                        ${item[header.key]?.others ? "owner-info" : ""} ${
                                          parsedValue?.color_code && `p-0.5 rounded-[5px] px-2 border`
                                        } ${parsedValue?.color_code && tableDetail?.tableHeading === "All Tasks" && `!rounded-[25px]`} `}
                                      style={{
                                        ...(parsedValue?.color_code && tableDetail?.tableHeading === "All Tasks"
                                          ? {
                                              backgroundColor: `${parsedValue.color_code.trim()}1A`,
                                              color: parsedValue.color_code.trim(),
                                              borderColor: parsedValue.color_code.trim(),
                                            }
                                          : parsedValue?.color_code
                                            ? {
                                                backgroundColor: `${parsedValue.color_code.trim()}`,
                                                color: "white",
                                              }
                                            : {}),
                                      }}
                                      onClick={
                                        navigateNameCondition && navigateNameCondition.includes(header.key)
                                          ? (e) => {
                                              e.stopPropagation();
                                              handleNavigate(rowKey, item, header);
                                            }
                                          : null
                                      }
                                    >
                                      <p
                                        className={`${
                                          header?.type === "text" &&
                                          `accounting-ellipsis w-[${
                                            ExtraFieldComponent && ExtraFieldComponent[header.key] ? "120px" : "120px"
                                          }]`
                                        }`}
                                        style={{
                                          width: columnWidths[headerIndex + 1],
                                          minWidth:
                                            tableDetail?.tableHeading?.toLowerCase() === "All Tasks"?.toLowerCase()
                                              ? ""
                                              : "2vw",
                                          maxWidth: "10vw",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {renderCellContent(
                                          item,
                                          header,
                                          searchTerms,
                                          tableSearchInput,
                                          rowKey,
                                          columnWidths[headerIndex + 1]
                                        )}
                                      </p>
                                      {ExtraFieldComponent && ExtraFieldComponent[header.key] && (
                                        <Fragment>{ExtraFieldComponent[header.key](item, header)}</Fragment>
                                      )}
                                    </div>

                                    {ExtraFieldComponent && ExtraFieldComponent[header?.type] && (
                                      <Fragment>
                                        {ExtraFieldComponent[header?.type](item, header, tableDetail)}
                                      </Fragment>
                                    )}
                                    {!navigateNameCondition?.includes(header.key) && (
                                      <button
                                        className={`ms-3 ${
                                          hoveredCell &&
                                          hoveredCell.rowIndex === rowKey &&
                                          hoveredCell.columnKey === header.key
                                            ? "opacity-1"
                                            : "opacity-0"
                                        }`}
                                      >
                                        <i className="bi bi-pencil"></i>
                                      </button>
                                    )}
                                  </Fragment>
                                )}
                              </Fragment>
                            )}
                          </div>
                        </td>
                      )
                    );
                  })}

                {tableDetail?.actionfield && tableDetail.actionfield(item)}
              </Fragment>
            )}
          </tr>

          {subTaskOpen?.includes(item?.id?.value) &&
            item?.sub_tasks?.value &&
            renderTableRows(item?.sub_tasks?.value, 0, true)}
          {isParent &&
            !isCollapsed &&
            item.items &&
            renderTableRows(
              tableDetail?.tableHeading === "Customer Table" ? item.items : item.setTablecellInput,
              level + 1
            )}
        </Fragment>
      );
    });
  };
  const handleAllChecked = () => {
    if (Object.keys(multiData)?.length) {
      setMultiData({});
    } else {
      const newData = groupedData.reduce((acc, item) => {
        acc[`${item?.id?.id}`] = true;
        return acc;
      }, {});
      setMultiData(newData);
    }
  };

  // const [activeTab, setActiveTab] = useState("All");

  // const handleTabClick = (tab) => {
  //   setActiveTab(tab);
  // };

  // const renderContent = () => {
  //   switch (activeTab) {
  //     case "All":
  //       return <div>All Content</div>;
  //     case "Data":
  //       return <div>Data Content</div>;
  //     case "Lead":
  //       return <div>Lead Content</div>;
  //     case "Deal":
  //       return <div>Deal Content</div>;
  //     case "Customer":
  //       return <div>Customer Content</div>;
  //     case "Project":
  //       return <div>Project Content</div>;
  //     default:
  //       return <div>All Content</div>;
  //   }
  // };

  //   const [newPayload, setNewPayload] = useState([]);
  const handleGroupingInAllTasks = (e, header, index) => {
    // const additionalPayload = {
    //   group_by_fields: header?.key, // Add your additional payload here
    // };
    setNewPayload((prev) => [
      ...prev, // Spread the previous array
      header?.key, // Add the new value (header?.key)
    ]);
  };
  //  useEffect(() => {
  //   if (newPayload) {
  //     const combinedPayload = {
  //       ...initialPayload, // Existing parameters
  //       ...newPayload,     // Additional parameters (e.g., filters)
  //     };
  //     console.log("combinedPayload",combinedPayload);

  //     // Only refetch if newPayload is not null
  //     refetchCustomerData({...combinedPayload,refetch:true});
  //   }
  // }, [newPayload, refetchCustomerData]); // Dependency on newPayload
  //console.log("groupedHeaders",groupedHeaders);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Fragment>
        {/* <div className="flex  justify-between pb-2 ">
     <div className="flex space-x-4 "> */}
        <div
          className={`flex bg-F1F6F9  ${isFullscreen && ""} justify-between droppingarea  ${
            isDraggingOver ? "highlighted" : ""
          } ${isDragAccurateLoc ? "locationhighlighted" : ""}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          {/* {tableDetail?.tableHeading==="Customer Table" && <div className="flex space-x-4 "> 
            


            <CustomerListTable
              key=""
              tableDetail={{
               
                forcefullyfreeze: true,
                tablename: (
                  <div>
                    <ul className="flex space-x-6 text-[#848687] font-300">
                      <button
                        className={`focus:outline-none  ${
                          activeTab === "All" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("All")}
                      >
                        All
                      </button>
                      <button
                        className={`focus:outline-none ${
                          activeTab === "Data" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("Data")}
                      >
                        Data
                      </button>
                      <button
                        className={`focus:outline-none ${
                          activeTab === "Lead" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("Lead")}
                      >
                        Lead
                      </button>
                      <button
                        className={`focus:outline-none ${
                          activeTab === "Deal" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("Deal")}
                      >
                        Deal
                      </button>
                      <button
                        className={`focus:outline-none ${
                          activeTab === "Customer" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("Customer")}
                      >
                        Customer
                      </button>
                      <button
                        className={`focus:outline-none ${
                          activeTab === "Project" ? "text-[#203C50] font-500" : ""
                        }`}
                        onClick={() => handleTabClick("Project")}
                      >
                        Project
                      </button>
                    </ul>

                    <div className="mt-4">{renderContent()}</div>
                  </div>
                ),
              }}
              
              tablePaginationData={handleChangePage}
            />

        </div>
        } */}

          <div className="flex items-center min-w-[50%]  ">
            {groupedHeaders?.length > 100 ? (
              groupedHeaders?.map((header, index) => (
                <span key={index} className="grouped-header">
                  {index === 0 ? (
                    "Group By "
                  ) : (
                    <span className="mx-1">
                      {" "}
                      <i className="bi bi-chevron-double-right"></i>{" "}
                    </span>
                  )}
                  <span className="bg-D7DFE3 text-1D4469 text-sm rounded capitalize">
                    {header?.value}{" "}
                    <button className="btn ms-2" onClick={() => handleRemoveHeader(index)}>
                      {" "}
                      <i className="bi bi-x-lg"></i>{" "}
                    </button>{" "}
                  </span>
                </span>
              ))
            ) : (
              <h4 className={tableDetail?.tablenameclass}>
                {" "}
                {tableDetail?.tablename} {tableDetail?.TableLeadFilter}
              </h4>
            )}
          </div>

          {draggedHeader?.value && <div className="dragged-value">Drop To Group By {draggedHeader?.value}</div>}

          {/* {TableTypeFilter && <div className="mb-2 min-h-[30px]">
            {TableTypeFilter && TableTypeFilter?.map((eachFilter)=>(
                <button disabled={eachFilter.value===UserTypeFlag} onClick={()=>handleTypeChange(eachFilter.value)} className={`w-fit min-w-[100px] px-2 py-1 rounded-full   ${eachFilter.value===UserTypeFlag?"bg-cyan-900 text-white" :"bg-cyan-50 text-black"} hover:border-[1px] hover:border-cyan-900 text-[10px] mr-2 box-border`}>{eachFilter.label}

        )} */}
          <div className=" ">
            {/* {isGridActive && ( */}
            {/* <div className="border-[1px] space-x-4 flex justify-center items-center rounded-l-lg rounded-r-lg border-[rgba(29, 68, 105, 0.20)] bg-white">
                <button
                  className={`text-12 text-848687 font-400 px-4 py-2 ${view === "Day" ? "selected" : ""}`}
                  onClick={() => changeview("Day")}>
                    Daily
                </button>
              ))}
          </div>} */}
          </div>
          <div className="flex justify-between items-center gap-2 me-1">
            <div className="mb-2 h-[25px] space-x-2 whitespace-nowrap">
              {TableTypeFilter && TableTypeFilter.length > 0 && (
                <FormControl
                  key={TableTypeFilter[0].value}
                  className="mr-2 sm:w-[134px] w-full"
                  sx={{
                    height: "32px",
                    fontSize: "12px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#E1E6EC",
                        borderWidth: "1px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#E1E6EC",
                        borderWidth: "1px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3F6F8F",
                        borderWidth: "1px",
                      },
                    },
                  }}
                >
                  <Select
                    value={selectedValue}
                    open={openDropdown === TableTypeFilter[0].value}
                    onClose={handleClose}
                    onOpen={() => handleOpen(TableTypeFilter[0].value)}
                    onChange={handleChange}
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          mt: 1,
                        },
                      },
                    }}
                    sx={{
                      backgroundColor: "white",
                      fontSize: "12px",
                      padding: "5px 0px",
                      minHeight: "28px",
                      color: "#1D4469",
                      "& .MuiSelect-icon": {
                        color: "#1D4469",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "white",
                      },
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem disabled value="" sx={{ display: "none", fontStyle: "normal" }}>
                      <em
                        style={{
                          fontStyle: "normal",
                          fontSize: "12px",
                          color: "#1D4469",
                          fontWeight: "400",
                        }}
                      >
                        Internal Users
                      </em>
                    </MenuItem>
                    {TableTypeFilter.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                          fontSize: "12px",
                          "&:hover": {
                            backgroundColor: "#E1E6EC",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "white",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#E1E6EC",
                          },
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {/* Render the second Select dropdown from TableActiveFilter */}
              {TableActiveFilter && (
                <FormControl
                  className="w-full sm:w-[126px]"
                  sx={{
                    height: "32px",
                    fontSize: "12px",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#E1E6EC",
                        borderWidth: "1px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#E1E6EC",
                        borderWidth: "1px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3F6F8F",
                        borderWidth: "1px",
                      },
                    },
                  }}
                >
                  <Select
                    value={UserActiveFlag}
                    onChange={(e) => handleActiveChange(e.target.value)}
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          mt: 1,
                        },
                      },
                    }}
                    sx={{
                      backgroundColor: "white",
                      fontSize: "12px",
                      padding: "5px 0px",
                      height: "32px",
                      color: "#1D4469",
                      "& .MuiSelect-icon": {
                        color: "#1D4469",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "white",
                      },
                      "&:hover": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    {TableActiveFilter.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                          fontSize: "12px",
                          "&:hover": {
                            backgroundColor: "#E1E6EC",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "white",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#E1E6EC",
                          },
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </div>

            {tableDetail?.tableHeading === "Customer Table" && (
              <div className="flex items-center  ml-2 space-x-2">
                <div className="flex items-center">
                  <FormControl
                    sx={{
                      width: 170,
                      fontSize: "12px",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1D4469",
                          borderWidth: "1px",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#1D4469",
                          borderWidth: "1px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderWidth: "1px",
                        },
                      },
                    }}
                  >
                    <Select
                      value={selectedValue}
                      // onChange={handleChange}
                      displayEmpty
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            mt: 1,
                          },
                        },
                      }}
                      sx={{
                        fontSize: "12px",
                        height: "28px",
                        padding: "0px",
                        backgroundColor: "white",
                        "&:focus": {
                          outline: "none",
                          boxShadow: "none",
                        },
                      }}
                    >
                      <MenuItem disabled value="" sx={{ display: "none", fontStyle: "normal" }}>
                        <em style={{ fontStyle: "normal", fontSize: "12px" }}>Applied Filter View</em>
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "12px" }}>Manish M</MenuItem>
                      <MenuItem sx={{ fontSize: "12px" }}>BD</MenuItem>
                      <MenuItem sx={{ fontSize: "12px" }}>IT</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div>
                  <div className="">
                    <FormControl
                      sx={{
                        width: 100,
                        fontSize: "12px",
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1D4469",
                            borderWidth: "1px",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1D4469",
                            borderWidth: "1px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderWidth: "1px",
                          },
                        },
                      }}
                    >
                      <Select
                        value={selectedValue}
                        onChange={handleChangeNew}
                        displayEmpty
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              mt: 1,
                              ml: 1.2,
                            },
                          },
                        }}
                        sx={{
                          fontSize: "12px",
                          height: "28px",
                          padding: "0px",
                          backgroundColor: "white",
                          "&:focus": {
                            outline: "none",
                            boxShadow: "none",
                          },
                        }}
                      >
                        <MenuItem disabled value="" sx={{ display: "none", fontStyle: "normal" }}>
                          <em style={{ fontStyle: "normal", fontSize: "12px" }}>More</em>
                        </MenuItem>
                        <MenuItem sx={{ fontSize: "12px" }} value={10}>
                          Bulk Delegation
                        </MenuItem>
                        <MenuItem sx={{ fontSize: "12px" }} value={20}>
                          Bulk Revoke
                        </MenuItem>
                        <MenuItem sx={{ fontSize: "12px" }} value={30}>
                          Save as View
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {isModalOpen && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                      <div className="bg-white p-5 rounded shadow-lg w-[530px]">
                        <div className="flex  justify-between border-b-2">
                          <h2 className="text-16 font-500 mb-2 text-[#434852] ">Save as View</h2>
                          <ClosePopUpIcn onClick={closeModal} />
                        </div>
                        <div className="pt-2">
                          <h1 className="mb-1 text-[#434852] text-14 font-400">Name</h1>
                          <input className="border-[#DFE2E5] w-[490px] pl-2 text-[#4F4F4F] text-12"></input>
                        </div>
                        <div className="sticky bottom-0 pt-4 flex justify-between  text-md w-full rounded-none z-[9998]">
                          <div className="space-x-1 text-[#2999BC]">
                            <input
                              className="focus:outline-none focus:ring-0 border-[#2999BC] rounded-sm"
                              type="checkbox"
                              id="check1"
                              name="check1"
                              value="Bike"
                            />
                            <label for="check1"> Make It Public</label>
                          </div>
                          <div className="">
                            <button
                              onClick={closeModal}
                              type="button"
                              className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
                            >
                              CANCEL
                            </button>
                            <button
                              onClick={closeModal}
                              type="submit"
                              className="w-28 text-white bg-1D4469 hover:bg-20486F ok-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="flex  space-x-1 items-center ">
              {tableDetail?.addbuttonToday}

              {tableDetail?.tablequickfilter && <div>{tableDetail?.tablequickfilter}</div>}

              <div className="">{tableDetail?.addbutton}</div>
              {tableDetail?.tableFilter && (
                <FilterSearchTh
                  tableThSearch={tableThSearch}
                  setTableThSearch={setTableThSearch}
                  setSearchTerms={setSearchTerms}
                  setSearchTermCount={setSearchTermCount}
                  tableSearchInput={tableSearchInput}
                  searchTerms={searchTerms}
                  className=""
                  setTableSearchInput={setTableSearchInput}
                  clearAllFilters={clearAllFilters}
                />
              )}

              {tableDetail?.tableSearch && (
                <SearchBar
                  data={tableSearchInput}
                  tableDetail={tableDetail}
                  event={handleGeneralSearch}
                  SearchOpen={false}
                  className=""
                />
              )}

              {tableDetail?.tableResizer && (
                <ToggleDensityMode event={toggleDensityMode} className="">
                  <button className="hover:text-254155  text-2541558A" type="button">
                    <i className={`${densityIcons[densityMode]} tableheaderfiltericon`}></i>
                  </button>
                </ToggleDensityMode>
              )}

              {/* {isTableMainDivPresent && tableDetail?.tableZoom && (
                <FullScreenMode event={(e) => toggleFullscreen(e)} className="ml-4">
                  {isFullscreen ? (
                    <i className="bi bi-fullscreen-exit tableheaderfiltericon text-254155 border border-253E50 px-1 rounded"></i>
                  ) : (
                    <i className="bi bi-fullscreen tableheaderfiltericon hover:text-254155  text-2541558A"></i>
                  )}
                </FullScreenMode>
              )} */}
            </div>

            {tableDetail?.tableheader && tableDetail?.tableHeading !== "Task Table" && (
              <SettingHeader
                thead={storedThead}
                setStoredThead={setStoredThead}
                handlePostThead={handlePostThead}
                ExtraFieldAddHeader={ExtraFieldAddHeader}
                GetAdditionalField={GetAdditionalField}
                GetAddFieldData={GetAddFieldData}
                tableDetail={tableDetail}
                handleMenuToggle={handleMenuToggle}
                setMenuVisible={setMenuVisible}
                menuVisible={menuVisible}
                extraField={extraField}
                setExtraField={setExtraField}
              />
            )}

            {(Object.keys(searchTerms).length > 0 ||
              tableSearchInput ||
              sortOrder === "asc" ||
              sortOrder === "desc" ||
              tableDetail?.quiFilter) && (
              <ClearAllFilter
                setTableSearchInput={setTableSearchInput}
                setSearchTerms={setSearchTerms}
                clearAllFilters={clearAllFilters}
                tableDetail={tableDetail}
              />
            )}
          </div>
        </div>

        <div id="fullscreen-container" className="overflow-y-auto mb-1">
          <div
            id={`${tableDetail.tableparentidclass || "tableparent"}`}
            className={`${tableDetail.tableparentidclass || "tableparent"} w-100  bg-white
          overflow-x-auto
          ${isListLoading ? "overflow-y-hidden" : "overflow-y-auto"} 
          hide-scrollbar-x

          scrollbar-hide
          ${tableDetail?.tablename ? "h-min-[25vh] max-h-full" : "custom-table-height-customer"}
          ${heightFull ? "h-full" : ""}
          customscrollbar`}
            ref={child1Ref}
          >
            <table
              ref={tableRef}
              id={`${tableDetail.tableidclass}`}
              className={` ${
                tableDetail.tableidclass
              }  min-w-full border border-neutral-200 text-center text-[13px] text-surface table-resizable rounded-lg ${
                groupedData?.length < 10 ? "" : ""
              }  text-2C495D font-poppins ${isFullscreen ? "h-full" : ""} ${densityMode} table-fixed`}
            >
              <thead className="capitalize sticky bg-white border">
                <tr>
                  {groupedHeaders?.length > 0 && (
                    <Fragment>
                      <th
                        scope="col"
                        className=" px-6 py-3 text-left border whitespace-nowrap border-x-0"
                        style={{ width: columnWidths[0] || "auto" }}
                      >
                        <div className={`flex justify-between items-center cursor-pointer`}>
                          <div
                            onMouseEnter={() => setHoveredHeader(groupedHeaders[0].key)}
                            onMouseLeave={() => setHoveredHeader(null)}
                          >
                            <div className="flex items-center relative">
                              <p>Group</p>
                              <button
                                className="cursor-pointer ml-3"
                                onClick={() => {
                                  handleGroupedToggle();
                                }}
                              >
                                {/* <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-three-dots-vertical"
                                  viewBox="0 0 16 16"
                                > 
                                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                </svg> */}
                                <ThreeDotHorizontal />
                              </button>
                              {groupedDropdown && (
                                <div className=" absolute top-8 left-5 right-0 mt-30 w-48 bg-white border border-gray-200 shadow-lg rounded-lg z-20">
                                  <ul className="py-2">
                                    {groupedHeaders?.map((item, index) => (
                                      <li
                                        key={index}
                                        className="px-4 py-2 cursor-pointer"
                                        onClick={() => handleRemoveHeader(index)}
                                      >
                                        <p>Stop Grouping By</p>
                                        <p>{item.key}</p>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              <button className="btn ms-3" onClick={() => removeAllGroupedHeaders()}>
                                {" "}
                                <i className="bi bi-x-lg"></i>{" "}
                              </button>{" "}
                            </div>
                          </div>
                          <div className="ms-3 w-[19px] h-[18px]">
                            {(hoveredHeader === groupedHeaders[0].key || tableThSearch) && (
                              <SortingFilter sortKey={sortKey} sortOrder={sortOrder} header={groupedHeaders[0]} />
                            )}
                          </div>
                        </div>

                        <div
                          className="resizer"
                          onMouseDown={(e) => handleMouseDown(0, e)}
                          // onDoubleClick={() => handleDoubleClick(0)}
                        />
                      </th>
                    </Fragment>
                  )}
                  {multiSelect && (
                    <th className="sticky left-[-1px] bg-white z-[99] w-[20px] sticky-col-customer" ref={firstColRef}>
                      <input
                        type="checkbox"
                        className=" cursor-pointer border-gray-300 hover:border-[#005B88] checked:bg-[#005B88]"
                        checked={Boolean(Object.keys(multiData).length > 1)}
                        onChange={handleAllChecked}
                      />
                    </th>
                  )}
                  {/* Table Header begins here */}
                  {renderTableHeaders() &&
                    renderTableHeaders().map((header, index) => (
                      <th
                        key={index}
                        scope="col"
                        className={`${stickyHeaders && stickyHeaders[header.key]?.name === header.key ? `bg-white z-[99] sticky-col-customer   ` : "relative"} pr-6 text-left  border whitespace-nowrap min-w-0 text-ellipsis border-x-0 `}
                        ref={index === 0 ? secondColRef : null}
                        style={{
                          // left: stickyHeaders && stickyHeaders[header.key]?.width,
                          width: storedThead[index]?.columnwidth
                            ? storedThead[index]?.columnwidth
                            : columnWidths[index + 1] || "auto",
                          minWidth: "2vw",
                        }}
                        onMouseEnter={() => setHoveredHeader(header.key)}
                      >
                        <div className="flex justify-between">
                          <div
                            className={`flex justify-between items-center cursor-pointer `}
                            onClick={() => sortData(header.key)}
                          >
                            <div
                              onMouseEnter={() => setHoveredHeader(header.key)}
                              // onMouseLeave={() => setHoveredHeader(null)}
                              className="text-ellipsis overflow-hidden"
                              style={{
                                maxWidth: `calc(${columnWidths[index + 1]}px - 1.5rem)` || "auto",
                                minWidth: "2vw",
                              }}
                            >
                              <button
                                className="btn cursor-grab invisible "
                                draggable={tableDetail.tableHeading !== "Task Table"}
                                onDragStart={() => handleDragStart(header.key, header.label)}
                              >
                                <i className="bi bi-grip-vertical opacity-55 text-sm"></i>
                              </button>

                              {header.label}
                            </div>

                            <div
                              className={`ms-3 w-[19px] h-[18px] ${tableDetail?.tableHeading === "Customer Table" ? "invisible" : ""}`}
                            >
                              {(hoveredHeader === header.key || tableThSearch) && (
                                <SortingFilter sortKey={sortKey} sortOrder={sortOrder} header={header} />
                              )}
                            </div>
                          </div>
                          {(tableDetail?.tableHeading == "Customer Table" ||
                            tableDetail?.tableHeading == "All Tasks") && (
                            <div className="relative">
                              <button
                                className="cursor-pointer"
                                onClick={(event) => toggleDots(event, index)}
                                //disabled={openStates[index]}
                              >
                                {/* <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-three-dots-vertical"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                </svg> */}
                                <ThreeDotHorizontal />
                              </button>
                              {openStates[index] && (
                                <div
                                  ref={dropdownRef}
                                  className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-lg z-100"
                                >
                                  <ul className="py-2">
                                    <li
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={() => {
                                        sortData(header.key, "asc");
                                        localStorage.setItem(
                                          `sort-${tableDetail.tableHeading}`,
                                          JSON.stringify({ key: header.key, order: "asc" })
                                        );
                                      }}
                                    >
                                      ↑ Sort by ASC
                                    </li>
                                    <li
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={() => {
                                        sortData(header.key, "desc");
                                        localStorage.setItem(
                                          `sort-${tableDetail.tableHeading}`,
                                          JSON.stringify({ key: header.key, order: "desc" })
                                        );
                                      }}
                                    >
                                      ↓ Sort by DESC
                                    </li>
                                    {!groupedHeaders.some((item) => item.key === header.key) && (
                                      <li
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={(e) => handleGroupedHeader(e, header, index)}
                                      >
                                        <p>Group By</p>
                                        <p>{header.label}</p>
                                      </li>
                                    )}
                                    {(() => {
                                      const groupedHeaderIndex = groupedHeaders.findIndex(
                                        (item) => item.key === header.key
                                      );

                                      if (groupedHeaderIndex !== -1) {
                                        return (
                                          <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => handleRemoveHeader(groupedHeaderIndex)}
                                          >
                                            <p>Stop Grouping By</p>
                                            <p>{header.label}</p>
                                          </li>
                                        );
                                      }
                                      return null;
                                    })()}

                                    <li
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={() => {
                                        handleHide(header);
                                      }}
                                    >
                                      Hide column
                                    </li>
                                    <li
                                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                      onClick={handleMenuToggle}
                                    >
                                      Manage columns
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div>
                          {tableThSearch && (
                            <div className="relative mt-2 pl-3.5">
                              <input
                                className=" h-[30px] rounded-md bg-FAFAFA text-[11px] border border-CED4DA   focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block"
                                type="text"
                                placeholder={`Filter By ${header.label.split(" ")[0]}`}
                                value={searchTerms[header.key] || ""}
                                onChange={(e) => handleInputChange(header.key, e.target.value)}
                              />
                              {searchTerms[header.key] && (
                                <button
                                  className="absolute inset-y-0 right-2"
                                  onClick={() => handleInputChange(header.key, "")}
                                >
                                  <i className="bi bi-x text-B4C0C8"></i>
                                </button>
                              )}
                            </div>
                          )}
                        </div>

                        <div
                          className="resizer px-[10px] "
                          onMouseDown={(e) => handleMouseDown(index + 1, e)}
                          // onClick={() => handleDoubleClick(index + 1)}
                        />
                      </th>
                    ))}
                  {/* <th></th> */}

                  {tableDetail?.actionfield && (
                    <th
                      className={`pr-6 py-3 text-left border whitespace-nowrap border-x-0 ${tableDetail?.tableHeading === "All Tasks" ? "sticky z-50 right-0" : ""} `}
                    >
                      {" "}
                      {tableDetail?.tableHeading === "All Tasks" ? "" : "Action"}{" "}
                    </th>
                  )}
                </tr>
              </thead>

              <tbody className="border">
                {/* {isListLoading && <MuiLoader isOpen={isListLoading} />} */}
                {/* centeredLoader() */}

                {Boolean(groupedData?.length) ? (
                  renderTableRows(groupedData)
                ) : (
                  <td colSpan={"10%"} className="text-black bg-white">
                    No Data to Show
                  </td>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {
          <div className=" flex justify-between align-centre">
            <div ref={paginationRef} className="flex min-w-fit w-auto">
              <div className="flex flex-grow justify-between items-center ">
                {(groupedData?.length > 20 || initialFilter?.total > 20) &&
                  initialFilter &&
                  (tableDetail?.tableHeading === "Customer Table" ||
                    tableDetail?.tableHeading === "All Users" ||
                    tableDetail?.tableHeading === "All Tasks" ||
                    tableDetail?.tableHeading === "All TaskPod") && (
                    <div className="mr-1">
                      <select
                        className="tblpadinationSelect form-select  h-7  focus:ring-0  focus:outline-none border-DDE1E3 focus:border-DDE1E3
"
                        onChange={(e) => DataElementShow(e)}
                        defaultValue={initialFilter.per_page}
                        value={perPage}
                      >
                        {/* <option value={10}>10</option> */}
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                        <option value={60}>60</option>
                        <option value={70}>70</option>
                        <option value={80}>80</option>
                        <option value={90}>90</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                    </div>
                  )}

                {(groupedData?.length >= 20 || initialFilter?.total >= 20) &&
                  initialFilter &&
                  [
                    "Customer Table",
                    "Task Table",
                    "All Users",
                    "All Tasks",
                    "Manage Company Permission",
                    "Manage Access",
                    "designations",
                    "company groups",
                    "doc types",
                    "business categories",
                    "departments",
                    "Admin",
                    "IT Group2",
                    "testing",
                    "sharukh khamnnn",
                    "roh",
                    "DM",
                  ].includes(tableDetail?.tableHeading) && (
                    <div className="bg-white ">
                      <Pagination initialFilter={initialFilter} onPageChange={handlePaginate} totalData={totalData} />
                    </div>
                  )}
              </div>
            </div>
            <div
              className={`flex justify-center items-center ${(tableDetail?.tableHeading === "Customer Table" || tableDetail?.tableHeading === "All Tasks") && (groupedData?.length >= 20 || initialFilter?.total >= 20) && initialFilter ? "w-1/2 ml-4" : "overflow-x-auto flex-1 overflow-y-hidden"}  `}
            >
              {tableDetail?.tableHeading === "Customer Table" && (
                <div className="mt-[4px] text-[20px]">
                  <i className="bi bi-three-dots-vertical"></i>
                </div>
              )}

              <button
                className={`z-50 mr-[-20px] bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-l-full flex items-center justify-center ${
                  scrollbarWidth === "0px" ? "hidden" : ""
                }`}
                onClick={() => handleScroll("previous")}
              >
                <span className="pt-[2px]" style={{ fontSize: "7.5px" }}>
                  &#9664;
                </span>
              </button>

              <div
                className={`flex-grow overflow-x-auto overflow-y-hidden scrollbar-thin customscrollbar1 w-[calc(100%-${scrollbarWidth})]`}
                style={{}}
                ref={scrollbarWrapperRef}
              >
                <div
                  style={{
                    width: `calc(${scrollbarWidth} - ${paginationRef?.current?.clientWidth}px)`,
                    height: "1px",
                  }}
                ></div>
              </div>

              <button
                className={`z-50 ml-[-20px]  bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-r-full flex items-center justify-center ${
                  scrollbarWidth === "0px" ? "hidden" : ""
                }`}
                onClick={() => handleScroll("next")}
              >
                <span className="pt-[2px]" style={{ fontSize: "7.5px" }}>
                  &#9654;
                </span>
              </button>
            </div>
          </div>
        }
      </Fragment>

      {openShowDetails && (
        <CustomerShowDetails open={openShowDetails} onClose={() => handleShowDetails(false)} Data={openShowDetails} />
      )}
    </div>
  );
};
export default CustomerListTable;
